//ライセンスページ /user/:uid
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import define from './define';
import users from './store/user'
import {Link, browserHistory} from 'react-router'
import './css/topVisitor1.css';
import firebase from 'firebase'
import {onLogin, TrustdockResultregister} from './firebase'
import ToggleDisplay from 'react-toggle-display';
import htmlspecialchars from 'htmlspecialchars';
import request from 'request-promise';
import {IsLoading} from './loading';

import './css/toast_custom.css'
import Toast from './components/toast'

import Modal from 'react-modal';

//実績表示component
import GetUserRecord from './components/GetUserRecord'
//ユーザランク取得処理
//連携サービス取得処理
import {
  getUserRank,
  getUserService
} from './functions/getUserRank'

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
  
    width                 : '400px',
    marginRight           : '-20%',
    borderRadius          : '10px',
    overflowX             : 'scroll',
    transform             : 'translate(-50%, -50%)',
    zIndex                : '100'
  },
  overlay : {
    backgroundColor:'rgba(0, 0, 0, 0.5)'
  }
};


export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rank:"",
      rank_img:"",
      rank_class:"",
      rank_jp:"",
      rank_class_jp:"",
      rank_chart:"",
      rating_str:"",

      modalIsOpen: false,
      displayName: "",
      photoURL: "",
      canvasImg:"",
      bio:"",
      isMylisence:true,

      modalType: null,
      shareURL:'',
      showShareUrl:'none',
      accessCounter:null,

      id_class: "icon-add-record clearfix",
      yahooauction_class: "icon-add-record clearfix",
      coconala_class: "icon-add-record clearfix",
      anyca_class: "icon-add-record clearfix",
      notteco_class: "icon-add-record clearfix",
      spacemarket_class: "icon-add-record clearfix",
      //20180425 rakuma
      // rakuma_class: "icon-add-record clearfix",
      //20180514 minne
      minne_class: "icon-add-record clearfix",  
        

      id_on: false,
      yahooauction_on: false,
      coconala_on: false,
      anyca_on: false,
      notteco_on: false,
      spacemarket_on: false,
      //20180425 rakuma
      // rakuma_on: false,
      //20180514 minne
      minne_on: false,   
            

      yahoo_auction:[],
      coconala:[],
      anyca:[],
      notteco:[],
      spacemarket:[],
      //20180425 rakuma
      // rakuma:[],
      //20180514 minne
      minne:[],      
         

      uid:"",
      myURL:"https://" + decodeURIComponent(window.location.hostname),
      isLogin:false,
      old_uid:'',

      popup_count:2,
      yahooauction_popup_count:3,
      coconala_popup_count:3,
      anyca_popup_count:3,
      notteco_popup_count:3,
      spacemarket_popup_count:3,
      //20180425 rakuma      
      // rakuma_popup_count:3,
      //20180514 minne      
      minne_popup_count:3,
     

      //toast message表示判定
      isToast:false, 

    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

// モーダルを開く
  openModal(e) {
    this.setState({modalType:e.currentTarget.dataset.modaltype})
    this.setState({modalIsOpen: true});
  }

// モーダルを閉じる
  closeModal() {
    this.setState({modalIsOpen: false});
  }

  openIdentification(e) {
    browserHistory.push("/personIdentification1/");
  }

  //props更新を検知して表示処理をしなおす
  componentWillReceiveProps = (state) => {
    //表示データの差し替えはユーザーIDの変更のみに絞る
    if(state.params.uid !== this.props.params.uid) {
      this.thisOnlogin()
      //newStateのuidを引数で渡す
      this.urlCopyReady(state.params.uid)
    }
  }

  //offにしないとrequestが走り続ける
  componentWillUnmount = () => {
    const {
      uid
    } = this.state
    firebase.database().ref("users/" + uid + "/").off('value')
    //on('value')をしている箇所全てのref()をoffにする
    firebase.database().ref('users/' + uid + "/ids/").off('value')
  }

  componentDidMount() {
    this.thisOnlogin()
    this.urlCopyReady()
  }

  thisOnlogin = () => {
    const {
      location
    } = this.props

    if(location.state && location.state.hasOwnProperty('isCertification')) {
      this.setState({isToast:location.state.isCertification})
    }

    var scope = this
    // ログインチェック
    onLogin((isLogin) => {
      scope.setState({isLogin:isLogin})

      // URLにIDが付与されている場合
      let path = window.location.pathname;
      let path_arr = path.split("/");
      var url_uid = "";
      if ("" !== path_arr[2] && null !== path_arr[2] && "undefined" !== typeof path_arr[2]) {
        url_uid = path_arr[2];
      }


      //ユーザー情報取得APIをたたく（非ログインユーザー用）
      let getUserData = (uid) => {
        let xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {
              //console.log(xhr.response)
              setUserData(JSON.parse(xhr.response),true)
            }
          }
        }
        xhr.open('POST','/api/getUser')
        xhr.setRequestHeader('Content-Type','application/json')
        xhr.send(JSON.stringify({uid:uid}))
      }

      // ユーザーのプロフィール取得　取得したusersテーブルの情報からtrustdock,ランク情報、連携サービス情報を取得  
      let setUserData = (snapshot,bool) => {
        //console.log(snapshot)
        let snap = typeof snapshot.val === 'function' ? snapshot.val() : snapshot
        // 存在しないユーザー、本登録が済んでいないユーザーではないか
        if (null !== snap) {
          if ("true" === snap.registComplete) {
            scope.setState({displayName: snap.displayName});
            if (snap.updatePhoto) {
              scope.setState({photoURL:snap.updatePhoto})
            } else if (snap.facebookId) {
              scope.setState({photoURL: "https://graph.facebook.com/" + snap.facebookId + "/picture?width=250&height=250"});
            } else {
              scope.setState({photoURL: '/img/common/m-profile-img@2x.png'})
            }
            scope.setState({canvasImg: "data:image/jpeg;base64," + snap.canvasImgURL});
            scope.setState({bio: snap.bio});
            //trustdockResultのstatusによる判定 -> MyRate仕様書参照 https://n-village.atlassian.net/wiki/spaces/MYR/pages/149585927/MyRate
            if ("approved" === snap.trustdockResult) {
              scope.setState({id_on: true});
              scope.setState({popup_count: 3});
              scope.setState({id_class: "icon-add-record record-connect clearfix"});
            } else if ("denied" === snap.trustdockResult || "reupload" === snap.trustdockResult) {
            //} else if ("denied" === snap.trustdockResult) {
              scope.setState({id_on: false});
              scope.setState({id_class: "icon-add-record record-error clearfix"});
              // ID登録がエラーまたは名前変更して再度ID認証が必要なユーザーでログインユーザーの場合、再アップロードさせる
              if ("" !== url_uid || url_uid === uid) {
                if (isMylisence) {
                  browserHistory.push("/newEdit");
                } else {
                  browserHistory.push("/404");  
                }
              }
            } else {
              // loading
              scope.setState({id_on: false});              
              scope.setState({id_class: "icon-add-record record-load clearfix"});
              // 本人認証が済んでいるか確認
              if (users.getMyUser() && users.getMyUser().trustdockId) {
                var options = {
                  url: define.TRUSTDOCK_CONFIG.review_api_url + users.getMyUser().trustdockId,
                  method: 'GET',
                  headers: define.TRUSTDOCK_CONFIG.review_api_headers
                }

                request(options, (err, res, body) => {
                  body = JSON.parse(body)
                  if ("" !== body.review && null !== body.review && "undefined" !== typeof body.review) {
                    if ("approved" === body.review.result || "denied" === body.review.result) {
                      TrustdockResultregister(body.review.result);
                    }
                  }
                });
              }
            }
            //自分のライセンスページだけアクセスカウンタ表示
            if(isMylisence) {
              if(snap.hasOwnProperty('access_counter')) {
                scope.setState({accessCounter:snap.access_counter})
              }
            } else {
              scope.setState({accessCounter:''})              
            }
            
            // ポイントテーブルを取得
            //外部ファイル化20180412
            getUserRank(uid,scope,bool,snap)
            // 各サービス連携データ読み取り
            //外部ファイル化20180413
            getUserService(uid,scope,snap)
            


          } else {
            // 本登録が済んでいないユーザーの場合
            browserHistory.push("/404");
          }
        } else {
          // 存在しないユーザーの場合
          browserHistory.push("/404");
        }
      }

      // ログインできているか
      var uid = "";
      let isMylisence = true
      if (true === isLogin) {
        uid = users.getMyUser().uid;
        // URLのIDと自分のIDが同じか
        if ("" !== url_uid && url_uid !== uid) {
          uid = url_uid;
          isMylisence = false
        }
        // URLのuid欄が空の場合書き換え
        if ("" === url_uid) {
          //console.log(uid)
          window.history.replaceState(null, null, "/user/" + uid);
        }
        scope.setState({uid:uid})

        //他人のライセンスで初回読み込みするとon()が他人のuidから引いたデータを監視するため表示ユーザーがかわるたび監視をoffにしてからあらたに表示するユーザーのuidで監視を再開する
        if(scope.state.old_uid) {
          var oldRef = firebase.database().ref("users/" + scope.state.old_uid + "/");
          oldRef.off('value');
        }
        var userRef = firebase.database().ref("users/" + uid + "/");
        userRef.on('value', setUserData);
        scope.setState({old_uid:uid})

      } else {
        //console.log('NOT_LOGIN')
        // uidの指定がなければログインページに飛ばす
        if ("" === url_uid) {
          browserHistory.push("/lpLogin");
          return
        }
        // ログインできていない場合はURLで指定されたIDの情報を参照
        uid = url_uid;
        isMylisence = false
        //非ログインユーザーはDBに直接アクセス権がないのでAPIを叩く
        getUserData(uid)
      }
      scope.setState({isMylisence:isMylisence})
      //scope.setState({uid:uid})


      //アクセスカウンタ更新
      let setAccessCounter = (uid) => {
        let xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if(xhr.readyState === 4) {
            if(xhr.status === 200) {              
            }
          }
        }

        xhr.open('POST','/api/setAccessCounter')

        xhr.setRequestHeader('Content-Type','application/json')
        //console.log(params)
        xhr.send(JSON.stringify({uid:uid}))
      }
      //自分のアカウント以外のuidの場合はアクセスカウンタをインクリメント
      if(!isMylisence) {
        //console.log(uid)
        setAccessCounter(uid)
      }
    }, false);
  }
  //コピーするエレメント生成※通常非表示
  showUrlCopyReady = () => {
    const {
      shareURL,
      showShareUrl
    } = this.state
    return (
      <p className="share-value" style={{ display: showShareUrl }}>{shareURL}?d={Date.now()}</p>
    )
  }
  //シェアURLの生成
  urlCopyReady = (params_id) => {
    const {
      myURL
    } = this.state
    let uid = params_id ? params_id : this.props.params.uid
    let shareURL = myURL + '/user/' + uid
    this.setState({ shareURL: shareURL })
  }
  //クリップボードにコピーする処理
  urlCopy = () => {
    this.setState({ showShareUrl: 'block' })
    setTimeout(() => {
      let shareValue = document.querySelector('.share-value')
      let selection = window.getSelection()
      if (selection.rangeCount > 0) selection.removeAllRanges()
      let range = document.createRange()
      range.selectNode(shareValue)
      selection.addRange(range)
      alert('コピーしました。')
      document.execCommand('copy')
      this.setState({ showShareUrl: 'none' })
    }, 300)
  }
  //アクセスカウンター表示
  showAccessCounter = () => {
    const {
      accessCounter
    } = this.state
    if(!accessCounter) return
    return (
      <p className="text-center user-access-counter">総アクセス数：{accessCounter}</p>
    )
  }
  //ユーザのデータ（ランク、画像パス、名前）がsetStateされるまでローディング表示
  isLoading = () => {
    const {
      rank_chart,
      photoURL,
      displayName
    } = this.state
    if(rank_chart && photoURL) {
      return (
        <div className="block-thum clearfix">
          <img alt="" className="user-chart" src={rank_chart} />
          <img alt="" className="user-thum" src={photoURL} />
          <p className="text-center user-name">{htmlspecialchars(displayName)}</p>
          <p className="text-center user-address">Japan</p>
          { this.showAccessCounter() }
        </div>
      )
    } else {
      return IsLoading()
    }
  }

  //toastメッセージ
  returnToast = () => {
    const {
      isToast,
    } = this.state
    const {
      location
    } = this.props    
    if(isToast) {
      if(location.state.hasOwnProperty('isCertification')) {
        let copyUid = JSON.parse(JSON.stringify(location.state))
        //Toast hideの後の処理が必要な場合callback属性で渡す
        let callback = () => {
          this.setState({isToast:false})
          browserHistory.replace({
            pathname: '/user/' + copyUid.uid,
            state: {}
          })
        }
        //下記の通りelementをnotifyMessage属性に渡す※toast-successまたはtoast-caution
        let message = (<div className="toast-success"><p>認証に成功しました。</p></div>)
        return (
          <Toast notifyMessage={message} callback={callback} />
        )
      }
    }
  }

render(){
  const {
    shareURL
  } = this.state
  return (
    <div>
      {this.returnToast()}
      <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-topVitor1">

          <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          ariaHideApp={false}
          contentLabel="Example Modal">
            <div className="modal-close" onClick={this.closeModal}></div>

                <div className="block-add-record">
                <ToggleDisplay if={this.state.modalType === "1"}>
                  <h2 className="subtitle-en">Add Records</h2>
                  <span className="subtitle-ja">さらにアカウントを連携</span>
                  <div className="block-icon-add-record" >
                  { /* ====コメント=============================================================
                    div.icon-add-recordにrecord-connectクラスがある場合checkアイコン表示
                   ============================================================================
                 */ }
                    <div className="icon-add-record record-connect clearfix">
                      <img alt="" className="icon" src="/img/common/icon_fb.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">Facebook</span>
                    </div>
                    <div className="icon-add-record record-connect clearfix">
                      <img alt="" className="icon" src="/img/common/icon_tel2.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">SMS</span>
                    </div>
                    <div className={this.state.id_class}>
                      <img alt="" className="icon" src="/img/common/icon_id.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">&nbsp;&nbsp;ID&nbsp;&nbsp;</span>
                    </div>
                    <Link to="/topUser4?domain=yahoo_auction" className={this.state.yahooauction_class}>
                      <img alt="" className="icon" src="/img/common/icon_yahooauction.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">Yahoo auction</span>
                    </Link>
                    <Link to="/topUser4?domain=coconala" className={this.state.coconala_class}>
                      <img alt="" className="icon" src="/img/icons/icon_coconala.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">coconala</span>
                    </Link>
                    <Link to="/topUser4?domain=anyca" className={this.state.anyca_class}>
                      <img alt="" className="icon" src="/img/common/icon_anyca.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">Anyca</span>
                    </Link>
                    <Link to="/topUser4?domain=notteco" className={this.state.notteco_class}>
                      <img alt="" className="icon" src="/img/common/icon_notteco.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">notteco</span>
                    </Link>
                    <Link to="/topUser4?domain=spacemarket" className={this.state.spacemarket_class}>
                      <img alt="" className="icon" src="/img/common/icon_spacemarket.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">Spacemarket</span>
                    </Link>
                    {/* 20180425 rakuma
                    <Link to="/topUser4?domain=rakuma" className={this.state.rakuma_class}>
                      <img alt="" className="icon" src="/img/common/icon_rakuma.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">rakuma</span>
                    </Link> */}
                    {/* 20180514 minne */}
                    <Link to="/topUser4?domain=minne" className={this.state.minne_class}>
                      <img alt="" className="icon" src="/img/common/icon_minne.png" />
                      <img alt="" className="icon-check" src="/img/common/check.png" />
                      <img alt="" className="icon-error" src="/img/icons/icon_status_ng.png" />
                      <img alt="" className="icon-load" src="/img/icons/icon_status_load.png" />
                      <span className="icon-title">minne</span>
                    </Link>     
                                                   
                  </div>
                  </ToggleDisplay>

                <ToggleDisplay if={this.state.modalType === "2"}>
                  <h2 className="subtitle-en">Page Share</h2>
                  <span className="subtitle-ja">このページをシェア</span>
                  <div className="block-icon-add-record" >
                  { /* ====コメント=============================================================
                    div.icon-add-recordにrecord-connectクラスがある場合checkアイコン表示
                   ============================================================================
                 */ }
                    <div className="icon-add-record record-connect clearfix" onClick={this.urlCopy}>
                      <img alt="" className="icon icon-shadow" src="/img/icons/link.png" />
                      <span className="icon-title">URLコピー</span>
                    </div>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${shareURL}?d=${Date.now()}`} target="_blank" className="icon-add-record record-connect clearfix">
                      <img alt="" className="icon icon-shadow" src="/img/icons/facebook.png" />
                      <span className="icon-title">Facebook</span>
                    </a>
                    <a href={`http://twitter.com/share?url=${shareURL}?d=${Date.now()}`} target="_blank" className="icon-add-record record-connect clearfix">
                      <img alt="" className="icon icon-shadow" src="/img/icons/twitter.png" />
                      <span className="icon-title">Twitter</span>
                    </a>
                    <a href={`http://line.me/R/msg/text/?${shareURL}?d=${Date.now()}`} target="_blank" className="icon-add-record record-connect clearfix">
                      <img alt="" className="icon icon-shadow" src="/img/icons/line.png" />
                      <span className="icon-title">LINE</span>
                    </a>

                  </div>
                  </ToggleDisplay>
                </div>
          </Modal>
    
        <Header/>

        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-rank">
                  <img alt="" className="icon-rank" src={this.state.rank_img} />
                  <div className="font-rank">

                    <p className={this.state.rank_class}>{this.state.rank}</p>
                    <p className={this.state.rank_class_jp}>{this.state.rank_jp}</p>
                  </div>
                </div>

                { this.isLoading() }

                <div className="block-description clearfix">
                  <img alt="" className="img_comment" src="/img/common/img_comment.png" />
                  <p className="user-description">{this.state.bio ? htmlspecialchars(this.state.bio) : "こんにちは。よろしくお願いします！"}</p>
                </div>
                <ToggleDisplay if={this.state.isLogin}>
                <p data-modaltype="2" onClick={this.openModal} className="btn-share" target="_blank"><img alt="" /><span>このページをシェア</span></p>
                </ToggleDisplay>
                <ToggleDisplay if={this.state.isMylisence}>
                <p onClick={this.openIdentification} className="btn-share"><img alt="" /><span>本人証明ページをシェア</span></p>
                </ToggleDisplay>
                <div className="line-dashed"></div>
                <div className="block-achievement">
                  <h2 className="subtitle-en">Records</h2>
                  <span className="subtitle-ja">実績</span>

                  <GetUserRecord state={this.state} openModal={this.openModal}/>

                </div>
                <div className="line-dashed"></div>
                <div className="block-rating-report">
                  <h2 className="subtitle-en">Rating Report</h2>
                  <span className="subtitle-ja">信用度レポート</span>
                  <div className="block-rank">
                    <img alt="" className="icon-rank" src={this.state.rank_img} />
                    <div className="font-rank">
                      <p className={this.state.rank_class}>{this.state.rank}</p>
                      <p className={this.state.rank_class_jp}>{this.state.rank_jp}</p>
                    </div>
                  </div>
                  <p className="rating-comment">{this.state.rating_str}</p>
                </div>
              </div>

            </div>
            <ToggleDisplay if={!this.state.isLogin}>
            <Link to=""><img alt="" className="footer-banner" src="/img/common/img_banner.png" /></Link>
            </ToggleDisplay>
            <Footer/>
          </div>
        </div>
      </div>
    </div>

  {this.showUrlCopyReady()}
  </div>
  )
}

}



// WEBPACK FOOTER //
// ./src/topUser1.js